unit View.UF.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewUFEdit = class(TForm)
    pnlMessage: TPanel;
    lbMessage: TLabel;
    btCloseMessage: TButton;
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbID: TLabel;
    edID: TDBEdit;
    lbNome: TLabel;
    edNome: TDBEdit;
    lbSigla: TLabel;
    edSigla: TDBEdit;
    lbCodigo_IBGE: TLabel;
    edCodigo_IBGE: TDBEdit;
    XDataClientUFGet: TXDataWebClient;
    XDataClientUFDelete: TXDataWebClient;
    UFDataset: TXDataWebDataSet;
    UFDatasetID: TIntegerField;
    UFDatasetNome: TStringField;
    UFDatasetSigla: TStringField;
    UFDatasetCodigo_IBGE: TIntegerField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientUFGetLoad(Response: TXDataClientResponse);
    procedure XDataClientUFDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientUFDeleteError(Error: TXDataClientError);
    procedure UFDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewUFEdit: TFViewUFEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewUFEdit }

procedure TFViewUFEdit.btSaveClick(Sender: TObject);
begin
  if UFDataset.State in dsEditModes then
  begin
        UFDataset.Post;
    UFDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewUFEdit.btDeleteClick(Sender: TObject);
begin
  if UFDataset.State in dsEditModes then
    UFDataset.Post;
  XDataClientUFDelete.Delete(UFDataset.EntitySetName,
    TJSObject(UFDataset.CurrentData));
end;


class function TFViewUFEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewUFEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewUFEdit.InsertEntity;
begin
  UFDataset.Close;
  UFDataset.SetJsonData('{}');
  UFDataset.Open;
  UFDataset.Insert;
end;

class function TFViewUFEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewUFEdit(AForm).FInserting := AInserting;
    TFViewUFEdit(AForm).FId := AId;
    TFViewUFEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewUFEdit(AForm).InsertEntity
    else
      TFViewUFEdit(AForm).LoadEntity;
    TFViewUFEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewUFEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewUFEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    UFDataset.Connection.Model.DefaultSchema.FindEntityType(
      UFDataset.EntitySetName
    )
  );
  XDataClientUFGet.Get(UFDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewUFEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewUFEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewUFEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewUFEdit.XDataClientUFGetLoad(Response: TXDataClientResponse);
begin
  UFDataset.Close;
  UFDataset.SetJsonData(Response.Result);
  UFDataset.Open;
  
  UFDataset.Edit;  
end;

procedure TFViewUFEdit.XDataClientUFDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewUFEdit.XDataClientUFDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewUFEdit.UFDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewUFEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewUFEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbID := TLabel.Create('view.uf.form.lbID');
  lbNome := TLabel.Create('view.uf.form.lbNome');
  lbSigla := TLabel.Create('view.uf.form.lbSigla');
  lbCodigo_IBGE := TLabel.Create('view.uf.form.lbCodigo_IBGE');
  pnlMessage := TPanel.Create('view.uf.form.message');
  lbMessage := TLabel.Create('view.uf.form.message.label');
  btCloseMessage := TButton.Create('view.uf.form.message.button');
  btCancel := TButton.Create('view.uf.form.btBack');
  btSave := TButton.Create('view.uf.form.btSave');
  btDelete := TButton.Create('view.uf.form.btDelete');
  edID := TDBEdit.Create('view.uf.form.edID');
  edNome := TDBEdit.Create('view.uf.form.edNome');
  edSigla := TDBEdit.Create('view.uf.form.edSigla');
  edCodigo_IBGE := TDBEdit.Create('view.uf.form.edCodigo_IBGE');
  DataSource := TDataSource.Create(Self);
  UFDataset := TXDataWebDataSet.Create(Self);
  UFDatasetID := TIntegerField.Create(Self);
  UFDatasetNome := TStringField.Create(Self);
  UFDatasetSigla := TStringField.Create(Self);
  UFDatasetCodigo_IBGE := TIntegerField.Create(Self);
  XDataClientUFGet := TXDataWebClient.Create(Self);
  XDataClientUFDelete := TXDataWebClient.Create(Self);

  lbID.BeforeLoadDFMValues;
  lbNome.BeforeLoadDFMValues;
  lbSigla.BeforeLoadDFMValues;
  lbCodigo_IBGE.BeforeLoadDFMValues;
  pnlMessage.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  btCloseMessage.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  edID.BeforeLoadDFMValues;
  edNome.BeforeLoadDFMValues;
  edSigla.BeforeLoadDFMValues;
  edCodigo_IBGE.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  UFDataset.BeforeLoadDFMValues;
  UFDatasetID.BeforeLoadDFMValues;
  UFDatasetNome.BeforeLoadDFMValues;
  UFDatasetSigla.BeforeLoadDFMValues;
  UFDatasetCodigo_IBGE.BeforeLoadDFMValues;
  XDataClientUFGet.BeforeLoadDFMValues;
  XDataClientUFDelete.BeforeLoadDFMValues;
  try
    Name := 'FViewUFEdit';
    Width := 593;
    Height := 373;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbID.SetParentComponent(Self);
    lbID.Name := 'lbID';
    lbID.Left := 24;
    lbID.Top := 192;
    lbID.Width := 15;
    lbID.Height := 13;
    lbID.Caption := 'ID:';
    lbID.HeightPercent := 100.000000000000000000;
    lbID.WidthPercent := 100.000000000000000000;
    lbNome.SetParentComponent(Self);
    lbNome.Name := 'lbNome';
    lbNome.Left := 24;
    lbNome.Top := 219;
    lbNome.Width := 31;
    lbNome.Height := 13;
    lbNome.Caption := 'Nome:';
    lbNome.HeightPercent := 100.000000000000000000;
    lbNome.WidthPercent := 100.000000000000000000;
    lbSigla.SetParentComponent(Self);
    lbSigla.Name := 'lbSigla';
    lbSigla.Left := 24;
    lbSigla.Top := 246;
    lbSigla.Width := 26;
    lbSigla.Height := 13;
    lbSigla.Caption := 'Sigla:';
    lbSigla.HeightPercent := 100.000000000000000000;
    lbSigla.WidthPercent := 100.000000000000000000;
    lbCodigo_IBGE.SetParentComponent(Self);
    lbCodigo_IBGE.Name := 'lbCodigo_IBGE';
    lbCodigo_IBGE.Left := 24;
    lbCodigo_IBGE.Top := 273;
    lbCodigo_IBGE.Width := 66;
    lbCodigo_IBGE.Height := 13;
    lbCodigo_IBGE.Caption := 'Codigo_IBGE:';
    lbCodigo_IBGE.HeightPercent := 100.000000000000000000;
    lbCodigo_IBGE.WidthPercent := 100.000000000000000000;
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 296;
    pnlMessage.Top := 113;
    pnlMessage.Width := 273;
    pnlMessage.Height := 60;
    pnlMessage.TabOrder := 0;
    lbMessage.SetParentComponent(pnlMessage);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 16;
    lbMessage.Top := 24;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.HeightPercent := 100.000000000000000000;
    lbMessage.WidthPercent := 100.000000000000000000;
    btCloseMessage.SetParentComponent(pnlMessage);
    btCloseMessage.Name := 'btCloseMessage';
    btCloseMessage.Left := 248;
    btCloseMessage.Top := 11;
    btCloseMessage.Width := 22;
    btCloseMessage.Height := 25;
    btCloseMessage.Caption := 'x';
    btCloseMessage.HeightPercent := 100.000000000000000000;
    btCloseMessage.WidthPercent := 100.000000000000000000;
    SetEvent(btCloseMessage, Self, 'OnClick', 'btCloseMessageClick');
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 313;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.HeightPercent := 100.000000000000000000;
    btCancel.TabOrder := 1;
    btCancel.WidthPercent := 100.000000000000000000;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 313;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.HeightPercent := 100.000000000000000000;
    btSave.TabOrder := 4;
    btSave.WidthPercent := 100.000000000000000000;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 313;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.HeightPercent := 100.000000000000000000;
    btDelete.TabOrder := 5;
    btDelete.WidthPercent := 100.000000000000000000;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    edID.SetParentComponent(Self);
    edID.Name := 'edID';
    edID.Left := 221;
    edID.Top := 189;
    edID.Width := 200;
    edID.Height := 21;
    edID.HeightPercent := 100.000000000000000000;
    edID.TabOrder := 6;
    edID.Text := 'edID';
    edID.WidthPercent := 100.000000000000000000;
    edID.DataField := 'ID';
    edID.DataSource := DataSource;
    edNome.SetParentComponent(Self);
    edNome.Name := 'edNome';
    edNome.Left := 221;
    edNome.Top := 216;
    edNome.Width := 200;
    edNome.Height := 21;
    edNome.HeightPercent := 100.000000000000000000;
    edNome.TabOrder := 7;
    edNome.Text := 'edNome';
    edNome.WidthPercent := 100.000000000000000000;
    edNome.DataField := 'Nome';
    edNome.DataSource := DataSource;
    edSigla.SetParentComponent(Self);
    edSigla.Name := 'edSigla';
    edSigla.Left := 221;
    edSigla.Top := 243;
    edSigla.Width := 200;
    edSigla.Height := 21;
    edSigla.HeightPercent := 100.000000000000000000;
    edSigla.TabOrder := 8;
    edSigla.Text := 'edSigla';
    edSigla.WidthPercent := 100.000000000000000000;
    edSigla.DataField := 'Sigla';
    edSigla.DataSource := DataSource;
    edCodigo_IBGE.SetParentComponent(Self);
    edCodigo_IBGE.Name := 'edCodigo_IBGE';
    edCodigo_IBGE.Left := 221;
    edCodigo_IBGE.Top := 270;
    edCodigo_IBGE.Width := 200;
    edCodigo_IBGE.Height := 21;
    edCodigo_IBGE.HeightPercent := 100.000000000000000000;
    edCodigo_IBGE.TabOrder := 9;
    edCodigo_IBGE.Text := 'edCodigo_IBGE';
    edCodigo_IBGE.WidthPercent := 100.000000000000000000;
    edCodigo_IBGE.DataField := 'Codigo_IBGE';
    edCodigo_IBGE.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := UFDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    UFDataset.SetParentComponent(Self);
    UFDataset.Name := 'UFDataset';
    UFDataset.AfterApplyUpdates := UFDatasetAfterApplyUpdates;
    UFDataset.EntitySetName := 'Ufs';
    UFDataset.Connection := DMConnection.ApiConnection;
    UFDataset.Left := 176;
    UFDataset.Top := 8;
    UFDatasetID.SetParentComponent(UFDataset);
    UFDatasetID.Name := 'UFDatasetID';
    UFDatasetID.FieldName := 'ID';
    UFDatasetID.Required := True;
    UFDatasetNome.SetParentComponent(UFDataset);
    UFDatasetNome.Name := 'UFDatasetNome';
    UFDatasetNome.FieldName := 'Nome';
    UFDatasetNome.Required := True;
    UFDatasetNome.Size := 255;
    UFDatasetSigla.SetParentComponent(UFDataset);
    UFDatasetSigla.Name := 'UFDatasetSigla';
    UFDatasetSigla.FieldName := 'Sigla';
    UFDatasetSigla.Required := True;
    UFDatasetSigla.Size := 255;
    UFDatasetCodigo_IBGE.SetParentComponent(UFDataset);
    UFDatasetCodigo_IBGE.Name := 'UFDatasetCodigo_IBGE';
    UFDatasetCodigo_IBGE.FieldName := 'Codigo_IBGE';
    UFDatasetCodigo_IBGE.Required := True;
    XDataClientUFGet.SetParentComponent(Self);
    XDataClientUFGet.Name := 'XDataClientUFGet';
    XDataClientUFGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientUFGet, Self, 'OnLoad', 'XDataClientUFGetLoad');
    XDataClientUFGet.Left := 64;
    XDataClientUFGet.Top := 8;
    XDataClientUFDelete.SetParentComponent(Self);
    XDataClientUFDelete.Name := 'XDataClientUFDelete';
    XDataClientUFDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientUFDelete, Self, 'OnLoad', 'XDataClientUFDeleteLoad');
    SetEvent(XDataClientUFDelete, Self, 'OnError', 'XDataClientUFDeleteError');
    XDataClientUFDelete.Left := 64;
    XDataClientUFDelete.Top := 56;
  finally
    lbID.AfterLoadDFMValues;
    lbNome.AfterLoadDFMValues;
    lbSigla.AfterLoadDFMValues;
    lbCodigo_IBGE.AfterLoadDFMValues;
    pnlMessage.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    btCloseMessage.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    edID.AfterLoadDFMValues;
    edNome.AfterLoadDFMValues;
    edSigla.AfterLoadDFMValues;
    edCodigo_IBGE.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    UFDataset.AfterLoadDFMValues;
    UFDatasetID.AfterLoadDFMValues;
    UFDatasetNome.AfterLoadDFMValues;
    UFDatasetSigla.AfterLoadDFMValues;
    UFDatasetCodigo_IBGE.AfterLoadDFMValues;
    XDataClientUFGet.AfterLoadDFMValues;
    XDataClientUFDelete.AfterLoadDFMValues;
  end;
end;

end.
